export const config = {
  urlBaseMamApi: 'https://api.codev8.net/apicloud/v1.0',
  urlBaseClientApi: 'https://galgo-filmoteca-pre.galgo.tv',
  urlBaseDrm: "https://drm.flumotion.cloud/apicloud/v1.0",
  defaultFramesPerSecond: 24
}